import { render, staticRenderFns } from "./GrayBarGuidesNumber.vue?vue&type=template&id=2cb050af&"
import script from "./GrayBarGuidesNumber.vue?vue&type=script&lang=js&"
export * from "./GrayBarGuidesNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports